import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Clock } from "lucide-react";
import { api } from "@/lib/api";
import { CoverMedia } from "@/components/CoverMedia";

export default function Services() {
  const { data: services = [], isLoading } = useQuery({
    queryKey: ["services"],
    queryFn: () => api.get("/services").then((r) => r.data),
  });

  return (
    <div className="pt-28 pb-24 max-w-6xl mx-auto px-5" data-testid="services-page">
      <p className="font-mono-label uppercase tracking-[0.3em] text-xs text-[#D4AF37]">What We Offer</p>
      <h1 className="font-display text-5xl md:text-6xl text-white mt-3 mb-4">Services</h1>
      <p className="text-white/60 max-w-xl mb-12">Full-service media production, transparent pricing. Tap any service to see details and book.</p>

      {isLoading ? (
        <div className="text-white/40">Loading services…</div>
      ) : (
        <div className="grid md:grid-cols-2 gap-5">
          {services.map((s, i) => (
            <motion.div
              key={s.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              data-testid={`service-card-${i}`}
            >
              <Link to={`/services/${s.slug}`} className="group flex gap-4 bg-[#111] border border-white/10 rounded-2xl overflow-hidden hover:border-[#D4AF37]/40 transition-colors h-40">
                <div className="relative w-40 shrink-0 overflow-hidden">
                  <CoverMedia item={s} playSize="sm" />
                </div>
                <div className="flex-1 py-4 pr-4 flex flex-col justify-between min-w-0">
                  <div>
                    <p className="font-mono-label uppercase text-[10px] tracking-[0.2em] text-[#D4AF37]">{s.category}</p>
                    <h3 className="font-display text-xl text-white mt-1">{s.title}</h3>
                    <p className="text-white/50 text-xs mt-1 line-clamp-2">{s.description}</p>
                  </div>
                  <div className="flex items-center justify-between">
                    <div>
                      <span className="text-[#D4AF37] font-semibold">{s.price}</span>
                      {s.hourly_rate > 0 && (
                        <span className="text-white/40 text-xs flex items-center gap-1 mt-0.5">
                          <Clock size={11} /> ${s.hourly_rate}/hr
                        </span>
                      )}
                    </div>
                    <ArrowRight size={18} className="text-white/40 group-hover:text-[#D4AF37] transition-colors" />
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}
